export interface IAccountInterface {
	id: string;
	alias: string;
	permissionsStatus: string;
	status: number;
	tenant_name: string;
	uuid: string;
	cv_standalone: boolean;
	permissions?: {};
	schedule?: {
		active?: boolean;
	};
	is_master?: boolean;
	zd_enabled?: boolean;
	provider?: string;
	crawling: { [key: string]: number };
	master_payer_id?: 'standalone' | string;
	product_permissions?: OnboardingProductsEnum[];
}

export enum OnboardingProductsEnum {
	Kompass = 'Kompass',
	CM = 'CM',
	ZD = 'ZD',
}
